import { Box, Button, Grid, LinearProgress } from '@material-ui/core';
import { createTheme, lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { DateRange } from '@mui/lab/DateRangePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { TransitionProps } from '@mui/material/transitions';
import axios from "axios";
import jaLocale from 'date-fns/locale/ja';
import MaterialTable, { Localization } from 'material-table';
import moment from 'moment';
import React, { useEffect, useState, VFC } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { API_URL, ILLEGAL_ROUTE } from "../../Const";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';
import { createdConstructionNameState } from '../../globalStates/createConstructionName';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { blackBoardDesign } from '../../BlackBoardConst';

/* ダイアログ関連*/
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/*ダイアログ関連*/

const theme = createTheme({
  /*
  palette: {
    secondary: {
      main: "rgba(33, 150, 243, 1) !important",
    },
  },
  */
  overrides: {
    MuiTableRow: {
      hover: {
        "&:hover": {
          backgroundColor: "rgba(33, 150, 243, 0.25) !important"
        }
      }
    }
  }
});

const localizationJapanese: Localization = {
  error: "エラー",
  body: {
    emptyDataSourceMessage: "表示するレコードがありません。",
    filterRow: {
      filterTooltip: "フィルター",
    },
  },
  header: {
    actions: "アクション",
  },
  grouping: {
    groupedBy: "グループ化:",
    placeholder: "ヘッダーをドラッグ ...",
  },
  pagination: {
    firstTooltip: "最初のページ",
    firstAriaLabel: "最初のページ",
    previousTooltip: "前のページ",
    previousAriaLabel: "前のページ",
    nextTooltip: "次のページ",
    nextAriaLabel: "次のページ",
    labelDisplayedRows: "{from}-{to} 全{count}件",
    labelRowsPerPage: "ページあたりの行数:",
    lastTooltip: "最後のページ",
    lastAriaLabel: "最後のページ",
    labelRowsSelect: "件",
  },
  toolbar: {
    nRowsSelected: "{0} 行選択",
  },
};



const BorderLinearProgress = withStyles({
  root: {
    height: 30,
    width: 130,
    backgroundColor: lighten('#0000FF', 0.9),
  },
  bar: {
    backgroundColor: '#0000FF',
  },
})(LinearProgress);

const useStyles = makeStyles({
  table: {
    width: "99.9%",
    minWidth: 650
  },
  root: {
    flexGrow: 1,
  },
  margin: {
    margin: 10,
  },
});

/*      export     */
export const Inspectionlist: VFC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()
  const history = useHistory();
  const classes = useStyles();
  const constructionName = useRecoilValue(createdConstructionNameState);
  // const [blackBoardDesign, setBlackBoardDesign] = useRecoilState(blackBoardDesignState);

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理*/
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  /*ダイアログ処理*/

  /*id取得*/
  const { state } = useLocation();
  const conid = (state as any)?.conid;

  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')

  const [posts, setPosts] = useState<any[]>([])
  const [postslist, setPostsList] = useState<any[]>([])

  const setCreatedConstructionName = useSetRecoilState(createdConstructionNameState)

  const insStatusStr = new Map<string, string>([
    ["0", "未実施"],
    ["1", "実施中"],
    ["2", "完了"],
  ]);

  const slicedBlackBoardDesign = { ...blackBoardDesign }

  useEffect(() => {
    openLoading()

    const fetchCompanyData = async () => {
      try {
        const response = await axios.post(API_URL.COMPANY_GET,
          { "company_id": jsonlist.company.company_id },
          { headers: { Authorization: jsonlist.token.IdToken } },
        )
        const readBlackBoardDesign = response.data.data?.blackboard;
        if (readBlackBoardDesign !== undefined) {
          const newBlackBoardDesign = {
            "color": readBlackBoardDesign.blackboard_color,
            "opacity": readBlackBoardDesign.opacity_rate,
            "fontSize": readBlackBoardDesign.font_size,
            "fontColor": readBlackBoardDesign.font_color,
            "alignment": readBlackBoardDesign.character_alignment,
            "placement": readBlackBoardDesign.character_placement,
          }
          localStorage.setItem("blackboardDesign", JSON.stringify(newBlackBoardDesign));
        } else {
          const slicedBlackBoardDesign = { ...blackBoardDesign }
          localStorage.setItem("blackboardDesign", JSON.stringify(slicedBlackBoardDesign));
        }
      } catch (e) {
        console.error(e);
      }
    }


    fetchCompanyData();

    axios.post(API_URL.CONSTRUCTION_GET,
      {
        "construction_id": conid,
        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.dealer_info_id

      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const persons = res.data.data;
        console.log("persons", persons);
        const inslist = res.data.data.inspection_info;
        console.log(persons)
        const constructionData = { constructionName: persons.construction_name, userName: persons.user_name };
        localStorage.setItem("constructionData", JSON.stringify(constructionData));
        setPosts(persons)

        let insIdList = [];
        let checkResult = new Map<string, string>();
        for (const ins of inslist) {
          if (ins.inspection_status === "1") {
            insIdList.push(ins.inspection_info_id)
          }
        }
        axios.post(API_URL.CHECK_MEETING_ID, {
          "meetingIds": insIdList
        }).then(res => {
          for (const v of res.data) {
            checkResult.set(
              v.meetingId, v.status
            )
          }
          const displist = inslist?.map((item: any) => {
            console.log(checkResult.get(item.inspection_info_id))
            const insStatus = checkResult.get(item.inspection_info_id)
            if (insStatus === '2') {
              item.inspection_status = insStatus;
              axios.post(API_URL.INSPECTION_UPDATE,
                {
                  "company_id": jsonlist.user.company_id,
                  "dealer_info_id": jsonlist.user.dealer_info_id,
                  "construction_id": conid,
                  "inspection_info_id": item.inspection_info_id,
                  "inspection_info_name": item.inspection_info_name,
                  "blackboard": item.blackboard,
                  "inspection_url": item.inspection_url,
                  "inspection_date": item.inspection_date,
                  "inspection_time": item.inspection_time,
                  "inspection_work_type": item.inspection_work_type,
                  "inspection_kind": item.inspection_kind,
                  "common_number": item.common_number,
                  "inspection_status": item.inspection_status,
                  "template": "テンプレート",
                  "checklist_activation": item.checklist_activation,
                  "remarks": item.remarks,
                  "checklist": item.checklist,
                  "witness": item.witness,
                  "actor": item.actor
                },
                { headers: { Authorization: jsonlist.token.IdToken } },
              )
            }
            item.inspection_status_str = insStatusStr.get(item.inspection_status)
            return item
          });

          setPostsList(displist)
        });

      })
      .catch(error => {
        console.log(error)
        // ここでエラーになるのはstateが渡っていないかログインができていない可能性が高いのでまずは上位の一覧画面に遷移する
        history.push({ pathname: "/Constructionlist", state: { err: ILLEGAL_ROUTE, } });
      })
      .finally(() => {
        closeLoading()
      })
  }, []);




  const construction_name = (posts as any)?.construction_name;
  const address = (posts as any)?.address;
  const user_name = (posts as any)?.user_name;
  const contractor = (posts as any)?.contractor;
  const orderer = (posts as any)?.orderer;
  const start_date = (posts as any)?.start_date;
  const end_date = (posts as any)?.end_date;
  const overview = (posts as any)?.overview;
  const inspection_info = (posts as any)?.inspection_info;
  setCreatedConstructionName(construction_name)
  // localStorage.setItem("constructionName", construction_name);

  //console.log(inspection_info)
  //console.log(start_date)

  //const start_dcp = new Date(Number(start_date));

  const low: any = [
    start_date,
    end_date
  ];

  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);

  /*詳細画面へ*/

  const Linkto = (e: any) => {
    //console.log(e.inspection_info_id)
    history.push({
      pathname: "/Inspectiondetail", state:
      {
        Insid: e.inspection_info_id,
        conid: conid,
        orderer: orderer,
        construction_name: construction_name,
      }
    });
  }
  /*詳細画面へ*/

  const DelCheckSubmit = (e: any) => {
    handleClickOpen();
  }

  const clickSubmit = (e: any) => {
    /*スピナー*/
    if (!loading) {
      setSuccess(false);
      setLoading(true);
    }
    /*スピナー*/



    openLoading()
    // POST処理　削除
    axios.post(API_URL.CONSTRUCTION_DELETE,
      {
        "construction_id": conid,
        "company_id": jsonlist.user.company_id,
        "dealer_info_id": jsonlist.user.company_id
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        const del = res.data.data;
        setSuccess(true);
        setLoading(false);
        history.push({ pathname: "/Constructionlist", state: { conid: conid, construction_name: construction_name, orderer: orderer } });
      })
      .catch(error => {
        setSuccess(true);
        setLoading(false);
        console.log(error)
      })
      .finally(() => {
        closeLoading()
      })

  }

  return (

    <GenericTemplate title="工事詳細（検査一覧）">
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ color: "#0d47a1" }}>{"このデータを削除しますか？"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                <Button
                  style={{ color: "#fff", backgroundColor: "#1e88e5" }}
                  onClick={handleClose}
                >キャンセル</Button>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ m: 1, position: 'relative' }}>
                {loading
                  ?
                  <Button
                    style={{ width: "100px" }}
                    variant="contained"
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                  :
                  <Button
                    style={{ color: "#fff", backgroundColor: "red", width: "100px" }}
                    disabled={loading}
                    onClick={clickSubmit}
                  >削除する
                  </Button>
                }
                {loading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: green[500],
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      </div>

      <Stack spacing={3} margin={2}></Stack>

      <Grid container spacing={0}>
        <Grid item xs={5}>
        </Grid>
        <Grid item xs={5}>
        </Grid>
        <Grid item xs={2}>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button
                style={{ color: "#fff", backgroundColor: "red" }}
                variant="contained"
                onClick={DelCheckSubmit}
              >
                この工事を削除
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <div className="textBox">

        <Stack spacing={3} margin={2}>
          <Grid container spacing={0}>
            <Grid item xs={2} className="detail-title2">工事名</Grid>
            <Grid item xs={4}>
              <TextField
                variant="standard"
                inputProps={{ readOnly: true }}
                value={construction_name}
              />
            </Grid>
            <Grid item xs={2} className="detail-title2">工期</Grid>
            <Grid item xs={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
                <MobileDateRangePicker
                  startText="開始時期"
                  endText="終了時期"
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(startProps, endProps) => (
                    <React.Fragment>
                      <TextField value={moment(start_date).format("yyyy/MM/DD")} variant="standard" />
                      <Box sx={{ mx: 2 }}> 〜 </Box>
                      <TextField value={moment(end_date).format("yyyy/MM/DD")} variant="standard" />
                    </React.Fragment>
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Stack>

        <Stack spacing={3} margin={2}>
          <Grid container spacing={0}>
            <Grid item xs={2} className="detail-title2">請負者</Grid>
            <Grid item xs={4}>
              <TextField
                variant="standard"
                inputProps={{ readOnly: true }}
                value={user_name}
              />
            </Grid>
            <Grid item xs={2} className="detail-title2">概要</Grid>
            <Grid item xs={4}>
              <TextField
                variant="standard"
                inputProps={{ readOnly: true }}
                value={overview}
              />
            </Grid>
          </Grid>
        </Stack>
        <Stack spacing={3} margin={3}></Stack>
        <Stack spacing={3} margin={2}>
          <Grid container spacing={0}>
            <Grid item xs={2} className="detail-title2">発注者</Grid>
            <Grid item xs={4}>
              <TextField
                variant="standard"
                inputProps={{ readOnly: true }}
                value={orderer}
              />
            </Grid>
            <Grid item xs={6}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ m: 1, position: 'relative' }}>
                  <Button
                    style={{ color: "#fff", backgroundColor: '#FFA500' }}
                    variant="contained"
                    size="large"
                    component={Link}
                    to={{ pathname: "/InspectionlistEdit", state: { conid: conid } }}
                  >
                    工事情報編集
                  </Button>
                </Box>
              </Box>

            </Grid>
          </Grid>
        </Stack>
      </div>

      <Stack spacing={3} margin={4}></Stack>

      <Grid container spacing={3}>
        <Grid item sm={12} xs={12}>
          <Button
            className="btnlink"
            color="primary"
            variant="contained"
            size="large"
            component={Link}
            to={{ pathname: "/InspectionCreat", state: { conid: conid } }}
          >
            ＋ 検査新規作成
          </Button>
        </Grid>
      </Grid>

      <Stack spacing={3} margin={1}></Stack>


      <ThemeProvider theme={theme}>
        <MaterialTable
          options={{
            search: true,
            draggable: true,
            filtering: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: '#ececec',
              color: '#000',
              textAlign: "left",
              fontWeight: "600",
            },
            rowStyle: rowData => ({
              backgroundColor: (rowData.inspection_status === "0") ? '#fcfcfc' : ((rowData.inspection_status === "1") ? 'lightyellow' : 'gray')
            })
          }}
          columns={[
            {
              title: '状態',
              field: 'inspection_status_str',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '日時',
              field: 'inspection_date',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '工種',
              field: 'inspection_work_type',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '種別',
              field: 'inspection_kind',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '備考',
              field: 'remarks',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '立会者',
              field: 'witness[0].name',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
            {
              title: '土木共通仕様番号',
              field: 'common_number',
              cellStyle: {
                textAlign: "left",
                borderRight: "1px solid #ececec",
              },
              headerStyle: {
                borderRight: "1px solid #fcfcfc",
              },
            },
          ]}
          data={postslist}
          title="検査一覧"
          onRowClick={(event, rowData,) => Linkto(rowData)}
          localization={localizationJapanese}
        />
      </ThemeProvider>

      <Stack spacing={3} margin={1}></Stack>

      <Grid container spacing={3}>
        <Grid item sm={12} xs={12}>
          <Button
            style={{ color: "#fff", backgroundColor: "#FFA500" }}
            variant="contained"
            size="large"
            component={Link}
            to={{ pathname: "/Insoutput", state: { conid: conid, } }}
          >
            検査結果を出力
          </Button>
        </Grid>
      </Grid>

      <Stack spacing={3} margin={1}></Stack>
    </GenericTemplate>
  );
};

export default Inspectionlist;